import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {getAllData, postUsersData } from '../services/ApiCallingUserServices';
import AlertModel from './AlertModel';
import { GetLocalStorage } from '../components/commonClass/Session';

const SetPriceAlert = ({ showModal, setShowModal, setUnsubscribeSuccessfully, unsubscribeSuccessfully }) => {
    const dispatch = useDispatch();
    const userData = GetLocalStorage();
    const IsLoginModel = useSelector((state) => state.loginModeleShowOrHideReducer)

    const [priceAlert, setPriceAlert] = useState({ UserMasterId: userData?.userMasterID, IsPriceAlert: false });

    const getPriceAlert = async () => {
        await getAllData(`/customerui/v1/getusermasterprofilebyid?userMasterId=${userData?.userMasterID}`).then((rep) => {
            setPriceAlert({ ...priceAlert, IsPriceAlert: rep?.data?.IsPriceAlert })
        })
    };

    useEffect(() => {
        if (!IsLoginModel && userData?.userMasterID) {
            getPriceAlert();
        }
    }, [userData?.userMasterID, IsLoginModel])

    const updatePriceAlert = async (value) => {
        await postUsersData('/customerui/v1/insertorupdateusermasterpricealert', { ...priceAlert, IsPriceAlert: value }).then((rep) => {
            setShowModal(false)
            setPriceAlert({ ...priceAlert, IsPriceAlert: value })
            !value && setUnsubscribeSuccessfully(true)
        })
    }

    const handlePriceAlert = (value) => {
        if (userData) {
            if (!value) {
                setShowModal(true)
            } else {
                updatePriceAlert(value);
            }
        }
        else {
            dispatch({ type: "SHOW_OR_HIDE_LOGIN_MODEL", payload: true })
        }
    }

    const onClosedModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <div className="set-price-alert">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h4>Set up price alerts</h4>
                    <div className="form-check form-switch">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            style={{ zIndex: 0 }}
                            id="flexSwitchCheckDefault"
                            checked={priceAlert?.IsPriceAlert}
                            onChange={(e) => handlePriceAlert(e.target.checked)}
                        />
                    </div>
                </div>
                <p>Receive alerts when the prices for this route change.</p>
            </div>

            <AlertModel
                showModal={showModal}
                onClosedModal={onClosedModal}
                messages='If you unsubscribe, you will miss the latest fare & hotel details.'
                clickOnSecondButton={() => updatePriceAlert(false)}
                secondButtonTitle='unsubscribe'
            />

            <AlertModel
                showModal={unsubscribeSuccessfully}
                onClosedModal={() => setUnsubscribeSuccessfully(false)}
                messages='Successfully unsubscribed.'
                clickOnSecondButton={() => setUnsubscribeSuccessfully(false)}
                secondButtonTitle='Okay'
            />
        </>
    )
}

export default SetPriceAlert